const checkDiff = <T>(list: Array<T>) => new Set(list).size !== 1

const fillArray = <T>(value: T, timesToRepeat: number) => Array(timesToRepeat).fill(value)

const sumArray = (accumulator: number, initialValue: number) => accumulator + initialValue

type RemoveEmptyValuesArrayProps = string | number | undefined | null

const removeEmptyValuesArray = (list: Array<RemoveEmptyValuesArrayProps>) =>
  list.filter((value) => value)

const dynamicSort = <T>(property: keyof T) => {
  const sortOrder = 1

  return function (a: T, b: T) {
    const result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0
    return result * sortOrder
  }
}

const removeCodeAndDescriptionDuplicatedItems = (
  items: { Codigo: string; Descricao: string }[]
) => {
  const result = items.filter(
    (item, index, self) =>
      index ===
      self.findIndex((t) => t.Codigo === item.Codigo && t.Descricao === item.Descricao)
  )

  return result
}

export {
  checkDiff,
  fillArray,
  sumArray,
  dynamicSort,
  removeEmptyValuesArray,
  removeCodeAndDescriptionDuplicatedItems
}
